import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Toast } from 'antd-mobile';
import reporting_body from '../../static/images_ae/reporting/reporting_body.png';
import area_head from '../../static/images_ae/reporting/area_head.png';
import line_head from '../../static/images_ae/reporting/line_head.png';
import area_chest from '../../static/images_ae/reporting/area_chest.png';
import line_chest from '../../static/images_ae/reporting/line_chest.png';
import area_stomach from '../../static/images_ae/reporting/area_stomach.png';
import line_stomach from '../../static/images_ae/reporting/line_stomach.png';
import area_others from '../../static/images_ae/reporting/area_others.png';
import line_others from '../../static/images_ae/reporting/line_others.png';
import line_heart from '../../static/images_ae/reporting/line_heart.png';
import line_lungs from '../../static/images_ae/reporting/line_lungs.png';
import area_four_limbs from '../../static/images_ae/reporting/area_four_limbs.png';
import line_four_limbs from '../../static/images_ae/reporting/line_four_limbs.png';
import tip_top_select from '../../static/images_ae/reporting/tip_top_select.png';
import sympton_bg from '../../static/images_ae/reporting/sympton_bg.png';
import bg_back from '../../static/images_ae/reporting/bg_back.png';
import bg_finish_go_on from '../../static/images_ae/reporting/bg_finish_go_on.png';
import tip_bottom_select from '../../static/images_ae/reporting/tip_bottom_select.png';
import organ_heart from '../../static/images_ae/reporting/organ_heart.png';
import doctor_completed from '../../static/images_ae/reporting/doctor_completed.png';
import treatment_body from '../../static/images_ae/alkReport/treatment_body.png';
import treatment_next from '../../static/images_ae/alkReport/treatment_next.png';
import treatment_no_select from '../../static/images_ae/alkReport/treatment_no_select.png';
import treatment_top from '../../static/images_ae/alkReport/treatment_top.png';
import { withRouter } from 'react-router-dom';
import styles from './completed.module.scss';

const api = new ApiCore();

const Chest = (props: any) => {

    const [list, setList] = useState<any>([]);
    const [headSelected, setHeadSelected] = useState<any>(false);
    const [chestSelected, setChestSelected] = useState<any>(false);
    const [stomachSelected, setStomachSelect] = useState<any>(false);
    const [othersSelected, setOthersSelected] = useState<any>(false);
    const [fourLimbsSelected, setFourLimbsSelected] = useState<any>(false);
    const [selectedCount, setSelectedCount] = useState<any>(0);
    const [organs, setOrgans] = useState<any>(props.organs || {});
    const [organList, setOrganList] = useState<any>([]);
    const [symptoms, setSymptoms] = useState<any>(props.treatments || []);
    const [symptomRecords, setSymptomRecords] = useState<any>(props.symptomRecords || []);
    const [recordId, setRecordId] = useState<any>(props.recordId || []);
    const [activeOrgan, setActiveOrgan] = useState<any>('');
    const [hasSelected, setHasSelected] = useState<any>(false);

    useEffect(() => {
        window.document.title = 'ALK风险评估';
        initData();
        return () => {
        }
    }, [])

    const initData = () => {
        let _list = organs.organs || []
        if (_list) {
            setOrganList(_list);
        }
    }

    const symptomsSelected = (val: any, key: number) => {
        let count = 0;
        let _symptoms: any = symptoms.map((v: any) => {
            let _selected = !!v.selected;
            if (val.code === v.code) {
                _selected = !v.selected;
            }
            if (_selected) {
                count++;
            }
            return {
                ...v,
                selected: _selected
            }
        });
        setHasSelected(count > 0);
        setSymptoms(_symptoms)
    }

    const allCompleted = () => {
        // const symptomRecords: any = [];
        // [
        //     props.headOrgans,
        //     props.chestOrgans, 
        //     props.stomachOrgans, 
        //     props.limbsOrgans, 
        //     props.othersOrgans
        // ].forEach((item: any) => {
        //     (item.organs || []).forEach((vv: any) => {
        //         (vv.symptoms || []).forEach((vvv: any) => {
        //             if (vvv.selected) {
        //                 symptomRecords.push({
        //                     positionCode: item.code,
        //                     positionName: item.name,
        //                     organCode: vv.code,
        //                     organName: vv.name,
        //                     symptomCode: vvv.code,
        //                     symptomName: vvv.code ? vvv.name : vvv.value // 其他
        //                 })
        //             }
        //         });
        //     });
        // })
        // const hasSelected = symptoms.some((v: any) => v.selected);
        if (!hasSelected) {
            Toast.show('请选择治疗方式', 0.8);
            return;
        }
        const treatments = symptoms.filter((v: any) => v.selected).map((vv: any) => vv.code).join(';');
        let _symptomRecords = symptomRecords || props.symptomRecord || [];
        const mSymptomRecords: any = _symptomRecords.map((v: any) => {
            return {
                levelType: v.levelType,
                riskLevel: v.riskLevel,
                positionCode: v.positionCode,
                positionName: v.positionName,
                organCode: v.organCode,
                organName: v.organName,
                symptomCode: v.code,
                symptomName: v.code ? v.name : v.value // 其他
            }
        });
        const params = {
            otherTreatment: '',
            symptomRecords: mSymptomRecords,
            treatments
        };
        api.toSaveEvaluation(params).then((res: any) => {
            if (res.code == 0) {
                Toast.show('保存成功');
                props.onCompletedFinished(res.data || {});
            } else {
                Toast.show(res.message || '保存失败');
            }
        })
    }

    const onPopState = (event: any) => {
        props.onBack();
    }


    return (
        <div className={styles.ae_reporting}>
            {/* <div className={styles.tip_top_wrap}>
                <img className={styles.tip_top} src={tip_top_select} alt="" />
                <div className={styles.tip_top_text}>请从下列5个部位中选择您出现不适的部位</div>
            </div> */}
            {/* <div className={styles.area_body_container}>
                <div>
                    <div className={`${styles.area_base} ${styles.area_head} ${headSelected ? styles.area_active : ''}`} onClick={ () => { headSelect()} }>
                        <div className={`${styles.area_tl_l}`}></div>
                        <div className={`${styles.area_tl_t}`}></div>
                        <div className={`${styles.area_tr_r}`}></div>
                        <div className={`${styles.area_tr_t}`}></div>
                        <div className={`${styles.area_bl_l}`}></div>
                        <div className={`${styles.area_bl_b}`}></div>
                        <div className={`${styles.area_br_r}`}></div>
                        <div className={`${styles.area_br_b}`}></div>
                        <div className={styles.area_head_bottom}>
                            请你选择出现不良反应期间采用的治疗方式
                        </div>
                    </div>
                </div>
            </div> */}
            <div className={styles.treatment_top}>
                <img src={treatment_top} alt="" />
            </div>
            <div className={styles.choose_sympton}>
                <div className={styles.content_area}>
                    <div className={styles.sympton_title}>请选择您采用的一个或多个治疗方式：</div>
                    <div className={styles.sympton_content}>
                        {
                            (symptoms || []).map((val: any, key: number) =>(
                                <div className={`${val.selected ? styles.active : styles.un_active}`} key={key} onClick={() => { symptomsSelected(val, key)}}>
                                    {val.name}
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
            {/* <div className={styles.sympton_select}>
                <div className={styles.sympton_select_img_wrap}>
                    <img src={sympton_bg} alt="" />
                </div>
                <div className={styles.sympton_select_text_wrap}>
                    <div className={styles.sympton_select_text}>请选择一个或多个与您症状贴近的病症描述：</div>
                    <div className={styles.sympton_select_menu}>
                        {
                            symptoms && symptoms.map((val: any, key: number) => (
                                <div className={`${val.selected ? styles.menu_active : ''}`} onClick={() => { symptomsSelected(val, key) }}>{val.name}</div>
                            ))
                        }
                    </div>
                </div>
            </div> */}
            <div className={styles.btns_wrap}>
                <div className={styles.btns_finish_go_on} onClick={allCompleted}>
                    <img className={styles.bootom_top} src={hasSelected ? treatment_next : treatment_no_select} alt="" />
                </div>
            </div>
            <div className={styles.to_before} onClick={() => { props.onBack() }}>
                <span>返回上一步</span>
            </div>
        </div>
    )
}

export default withRouter(Chest);